import { StyledFlag } from 'baseui/phone-input';

const CustomFlag = (props) => {
  const { children, ...rest } = props;
  return <StyledFlag iso={props.$iso} {...rest} />;
}

export default CustomFlag;
